// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner_spinner__GpH8e","loading":"Spinner_loading__tACX3"};